import { Seo } from 'ui-components'
import { QueryProvider } from '~explore/providers/QueryProvider'
import { getCategoryTagsQueryFn } from '~explore/queries/useGetCategoryTags'
import { getPopularMapsQueryFn } from '~explore/queries/useGetPopularMaps'
import { Category_Tag_Type } from '~explore/types/__generated/gql/graphql'
import { Explore } from './Explore'

export type AppProps = Awaited<ReturnType<typeof getServerSideProps>>['props']

export const App = (props: AppProps) => {
  return (
    <QueryProvider>
      <Seo
        title='Mapstack Community - Discover the best community contributed maps'
        description='Explore the best maps chosen by the Mapstack community. Dive into a curated collection of the most insightful and visually compelling maps. Discover top-rated maps that highlight diverse data sets and powerful visualizations. Start exploring now!'
      />
      <Explore {...props} />
    </QueryProvider>
  )
}

export const getServerSideProps = async () => {
  const [
    getPopularMapsResults,
    getPrimaryTagsResults,
    getSecondaryTagsResults
  ] = await Promise.all([
    getPopularMapsQueryFn(),
    getCategoryTagsQueryFn({
      categoryTypes: [Category_Tag_Type.Primary],
      size: 3
    }),
    getCategoryTagsQueryFn({
      categoryTypes: [Category_Tag_Type.Secondary],
      size: 5
    })
  ])

  return {
    props: {
      getPopularMapsResults,
      getPrimaryTagsResults,
      getSecondaryTagsResults
    }
  }
}
